import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { playlistApi } from '../utils/api';

export default function PlaylistsPage() {
  const { token }    = useAuth();
  const navigate     = useNavigate();
  const [playlists, setPlaylists] = useState([]);
  const [loading, setLoading]     = useState(true);
  const [error, setError]         = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const data = await playlistApi.list(token);
      setPlaylists(data || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => { load(); }, [load]);

  const handleDelete = async (pl) => {
    if (!window.confirm(`Delete playlist "${pl.title}"?`)) return;
    try {
      await playlistApi.delete(pl.playlist_id, token);
      setPlaylists(ps => ps.filter(p => p.playlist_id !== pl.playlist_id));
    } catch (err) {
      alert(err.message);
    }
  };

  if (loading) return <div className="text-center mt-5"><div className="spinner-border" /></div>;

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="mb-0">My Playlists</h2>
        <button className="btn btn-success" onClick={() => navigate('/playlists/new')}>
          + New Playlist
        </button>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      {playlists.length === 0 ? (
        <div className="text-muted">
          No playlists yet. Click <strong>+ New Playlist</strong> to create one.
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table table-hover align-middle">
            <thead>
              <tr>
                <th>Title</th>
                <th style={{ width: '12rem' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {playlists.map(pl => (
                <tr key={pl.playlist_id}>
                  <td>{pl.title}</td>
                  <td>
                    <div className="d-flex gap-1">
                      <button
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => navigate(`/playlists/${pl.playlist_id}/review`)}
                      >
                        Review
                      </button>
                      <button
                        className="btn btn-sm btn-outline-secondary"
                        onClick={() => navigate(`/playlists/${pl.playlist_id}/edit`)}
                      >
                        Edit
                      </button>
                      <button
                        className="btn btn-sm btn-outline-info"
                        onClick={() => navigate(`/playlists/${pl.playlist_id}/export`)}
                      >
                        Export
                      </button>
                      <button
                        className="btn btn-sm btn-outline-success"
                        onClick={() => navigate(`/playlists/${pl.playlist_id}/submit`)}
                      >
                        Publish
                      </button>
                      <button
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => handleDelete(pl)}
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
